import { createFileRoute } from '@tanstack/react-router';
import { Stack } from '@osd/ui/stack';
import { CodeBlock } from '@osd/ui/code-block';
import { Section } from '@osd/ui/section';

/**
 * /ui/stack — live docs for the `Stack` primitive.
 */
export const Route = createFileRoute('/ui/_layout/stack')({
  component: StackPage,
});

function StackPage() {
  return (
    <Stack gap={6}>
      <Section title="Stack" hint="vertical or horizontal layout with consistent gap scale">
        <Stack gap={4}>
          <Stack gap={2}>
            <span>A</span>
            <span>B</span>
          </Stack>
          <Stack direction="row" gap={3}>
            <span>X</span>
            <span>Y</span>
          </Stack>
          <Stack direction="row" gap={2} justify="between">
            <span>Left</span>
            <span>Right</span>
          </Stack>
        </Stack>
      </Section>

      <Section title="Code example" hint="copy-pasteable usage">
        <Stack gap={5}>
          <CodeBlock
            title="Vertical stack (default)"
            language="tsx"
            code={`<Stack gap={4}>
  <Card><Card.Body>One</Card.Body></Card>
  <Card><Card.Body>Two</Card.Body></Card>
  <Card><Card.Body>Three</Card.Body></Card>
</Stack>`}
          />

          <CodeBlock
            title="Horizontal — row direction"
            language="tsx"
            code={`<Stack direction="row" gap={3}>
  <Button>Cancel</Button>
  <Button variant="primary">Save</Button>
</Stack>`}
          />

          <CodeBlock
            title="Justify — space-between"
            language="tsx"
            code={`<Stack direction="row" justify="between" align="center">
  <Heading level={2}>Users</Heading>
  <Button variant="primary">Invite</Button>
</Stack>`}
          />
        </Stack>
      </Section>
    </Stack>
  );
}
